import React from "react";
import InnerLayout from "../InnerLayout";
import { QuickFactsCard } from "./CampusLifePageParts";

const facilityImages = ["1.jpg", "2.jpg", "3.jpg", "5.jpg"].map(
  (filename, index) => ({
    src: `/mess-canteen/${filename}`,
    alt: `Mess and canteen facility ${index + 1}`,
  })
);

const MessAndCanteen = () => {
  const facility = {
    name: "Mess & Canteen",

    description:
      "The college provides excellent dining facilities through a well-maintained mess and two canteens located within the campus. These facilities cater to the daily needs of students and staff, offering hygienic, nutritious, and affordable food in a comfortable environment.",

    overview:
      "The management and operation of the mess and canteens are entrusted to experienced, skilled, and dedicated contractors who ensure quality food preparation and service. All dining facilities function on all working days and provide meals and refreshments at reasonable prices. To maintain high standards of hygiene and health, purified water from a Reverse Osmosis (RO) plant is used for cooking and drinking purposes. Hot water is also made available for both cooking and drinking.",

    highlights: [
      "Spacious and hygienic dining areas",
      "Nutritious and quality food at affordable rates",
      "RO-purified drinking water",
      "Hot water facility for cooking and drinking",
      "Experienced and professional catering management",
      "Separate mess and canteen facilities within the campus",
      "Clean and student-friendly environment",
    ],

    timings: [
      ["Breakfast", "7:00 AM – 9:00 AM"],
      ["Lunch", "12:45 PM – 1:45 PM"],
      ["Evening Snacks", "4:45 PM – 5:45 PM"],
      ["Dinner", "7:00 PM – 9:00 PM"],
    ],
  };
  const quickFacts = [
    ["Category", "Campus Life"],
    ["Facility", facility.name],
    ["Dining Facilities", "Mess and two canteens"],
    ["Operating Days", "All working days"],
    ["Water Facility", "RO-purified water"],
    ["Hot Water", "Available"],
    ["Meal Slots", String(facility.timings.length)],
  ];

  return (
    <InnerLayout
      title="Mess & Canteen"
      image="/Campus/messhero.jpg"
      breadcrumbs={[
        { label: "Campus Life", to: "/campus" },
        { label: "Mess & Canteen" },
      ]}
      sidebar={null}
    >
      <div className="grid lg:grid-cols-3 gap-10 items-start">
        <div className="vdit-prose lg:col-span-2">
          <h2
            className="text-3xl md:text-4xl text-brand font-semibold mb-5"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            {facility.name}
          </h2>

          <p>{facility.description}</p>

          <h3>Overview</h3>
          <p>{facility.overview}</p>

          <h3>Facilities Highlights</h3>
          <ul>
            {facility.highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <h3>Facility</h3>
          <div className="grid md:grid-cols-2 gap-5 not-prose">
            {facilityImages.map(({ src, alt }) => (
              <figure
                key={src}
                className="bg-white border border-brand/15 overflow-hidden"
              >
                <img
                  src={src}
                  alt={alt}
                  className="w-full aspect-[16/10] object-cover"
                  loading="lazy"
                />
              </figure>
            ))}
          </div>

          <h3>Dining Timings</h3>

          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr>
                <th className="border border-gray-300 p-3 text-left">
                  Meal
                </th>
                <th className="border border-gray-300 p-3 text-left">
                  Time
                </th>
              </tr>
            </thead>
            <tbody>
              {facility.timings.map(([meal, time]) => (
                <tr key={meal}>
                  <td className="border border-gray-300 p-3">{meal}</td>
                  <td className="border border-gray-300 p-3">{time}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h3>Dining Services</h3>
          <p>
            The institution strives to provide healthy, hygienic, and balanced
            meals, ensuring the well-being and comfort of students and staff
            throughout their academic journey.
          </p>
        </div>

        <aside className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36">
          <QuickFactsCard facts={quickFacts} />
        </aside>
      </div>
    </InnerLayout>
  );
};

export default MessAndCanteen;
